import { createSlice } from '@reduxjs/toolkit';

import { fetchArticleRelatedItems } from './articleRelatedItems.actions';
import { defaultArticleRelatedItemsSlice } from './articleRelatedItems.types';

const articleRelatedItemsSlice = createSlice({
    extraReducers: (builder) => {
        builder
            .addCase(fetchArticleRelatedItems.pending, (state) => {
                state.itemIds = [];
            })
            .addCase(fetchArticleRelatedItems.fulfilled, (state, action) => {
                state.itemIds = action.payload;
            })
            .addCase(fetchArticleRelatedItems.rejected, (state) => {
                state.itemIds = [];
            });
    },
    initialState: defaultArticleRelatedItemsSlice,
    name: 'articleRelatedItems',
    reducers: {},
});

export const { reducer: articleRelatedItemsReducer } = articleRelatedItemsSlice;
